import { Box, Button, CircularProgress, Typography } from '@mui/material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useState } from 'react'
import { UploadFileIcon } from 'src/v3/core/icons'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  successMessageChanged,
} from '../admin.slice'

export default () => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )
  let [uploading, setUploading] = useState<boolean>(false)

  let inviteUsers = (csvFile: FormData, linkedServiceID: string) =>
    axios.post<unknown>(
      `/api/admin/linked-service-user/bulk?linkedServiceID=${linkedServiceID}`,
      csvFile,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )

  let handleBulkUpload = (event: any) => {
    let input = event.target.files[0]
    let csvData = new FormData()
    csvData.append('csvFile', input)
    setUploading(true)

    inviteUsers(csvData, linkedService?.id || '')
      .then(() => setUploading(false))
      .then(() => dispatch(successMessageChanged('CSV uploaded successfully!')))
      .catch((err) => {
        setUploading(false)
        dispatch(
          errorMessageChanged(err?.response?.data || err?.response?.status),
        )
      })
  }

  return (
    <Box sx={{ mt: 1, width: 200 }}>
      <Typography variant="caption" color="text.secondary">
        Bulk Upload Users
      </Typography>
      {uploading ? (
        <Box>
          <CircularProgress size={30} />
        </Box>
      ) : (
        <label
          style={{
            cursor: 'pointer',
            marginBottom: 0,
            marginLeft: 0,
          }}
        >
          <Button
            startIcon={<UploadFileIcon />}
            color="primary"
            variant="outlined"
            component="span"
          >
            <input
              accept=".csv"
              style={{ display: 'none' }}
              type="file"
              onChange={handleBulkUpload}
            />
            Upload CSV
          </Button>
        </label>
      )}
      {/* // TODO: Remove this notice when the new onboarding flow is fully implemented */}
      <Typography variant="subtitle2" color="error" sx={{ mt: 0.5 }}>
        *NOTICE: Devs are currently testing a new onboarding flow with the Admin
        bulk upload. Please use the "Manage - Roster" page to add users for now.
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 0.5 }}>
        *The CSV should contain the columns: Email
      </Typography>
    </Box>
  )
}
